import React, { lazy } from "react";

// -- This file is generated by the build. Do not edit it directly.

const AccordionChevronLeft = lazy(()=> import("./examples/Accordion-Chevron-Left"));
const Accordionwithstyling = lazy(()=> import("./examples/Accordion-with-styling"));
const AutocompleteOptionNotonList = lazy(()=> import("./examples/Autocomplete-Option-Not-on-List"));
const ButtonDisabledwithTooltip = lazy(()=> import("./examples/Button-Disabled-with-Tooltip"));
const ButtonTrailingIcon = lazy(()=> import("./examples/Button-Trailing-Icon"));
const ComposedPageHeaderOverflowMenu = lazy(()=> import("./examples/Composed-Page-Header-Overflow-Menu"));
const ConditionalMenu = lazy(()=> import("./examples/Conditional-Menu"));
const CurrencyInputCustomHandler = lazy(()=> import("./examples/Currency-Input-Custom-Handler"));
const CustomButtonColor = lazy(()=> import("./examples/Custom-Button-Color"));
const CustomHideableInput = lazy(()=> import("./examples/Custom-Hideable-Input"));
const CustomMultiSelectChipwithSearchandKeyboardHandling = lazy(()=> import("./examples/Custom-Multi-Select-Chip-with-Search-and-Keyboard-Handling"));
const CustomSingleSelectChipwithSearch = lazy(()=> import("./examples/Custom-Single-Select-Chip-with-Search"));
const DataServerExample = lazy(()=> import("./examples/Data-Server-Example"));
const DatePickerCustomShortcutChips = lazy(()=> import("./examples/Date-Picker-Custom-Shortcut-Chips"));
const DatePickerPositioning = lazy(()=> import("./examples/Date-Picker-Positioning"));
const DatePickerflexibleDateInput = lazy(()=> import("./examples/Date-Picker-flexibleDateInput"));
const DateRangePickerAutoSelect = lazy(()=> import("./examples/Date-Range-Picker-Auto-Select"));
const DateRangePickerReset = lazy(()=> import("./examples/Date-Range-Picker-Reset"));
const DialogHideOverlay = lazy(()=> import("./examples/Dialog-Hide-Overlay"));
const DialogwithPagination = lazy(()=> import("./examples/Dialog-with-Pagination"));
const DialogwithStickyContent = lazy(()=> import("./examples/Dialog-with-Sticky-Content"));
const DialogwithaDatepicker = lazy(()=> import("./examples/Dialog-with-a-Datepicker"));
const Dialogwithdropdown = lazy(()=> import("./examples/Dialog-with-dropdown"));
const Dialogwithinputs = lazy(()=> import("./examples/Dialog-with-inputs"));
const DialogsWithDropdowns = lazy(()=> import("./examples/Dialogs-With-Dropdowns"));
const DropdownComposedMenuWidth = lazy(()=> import("./examples/Dropdown-Composed-Menu-Width"));
const DropdownCustomInput = lazy(()=> import("./examples/Dropdown-Custom-Input"));
const DropdownMenuWidth = lazy(()=> import("./examples/Dropdown-Menu-Width"));
const EditableTitle = lazy(()=> import("./examples/Editable-Title"));
const ErrorExample = lazy(()=> import("./examples/Error-Example"));
const FilterChipsWithColorSwatches = lazy(()=> import("./examples/Filter-Chips-With-Color-Swatches"));
const FlattenNestedObject = lazy(()=> import("./examples/Flatten-Nested-Object"));
const FortellisTheme = lazy(()=> import("./examples/Fortellis-Theme"));
const Fullscreenloader = lazy(()=> import("./examples/Full-screen-loader"));
const GroupListExample = lazy(()=> import("./examples/GroupList-Example"));
const InputChipErrorHandling = lazy(()=> import("./examples/Input-Chip-Error-Handling"));
const InputChipsCustomValidation = lazy(()=> import("./examples/Input-Chips-Custom-Validation"));
const InputErrorValidation = lazy(()=> import("./examples/Input-Error-Validation"));
const Inputerroriconcolor = lazy(()=> import("./examples/Input-error-icon-color"));
const LinkKeyboardNavigation = lazy(()=> import("./examples/Link-Keyboard-Navigation"));
const LinkwithTruncation = lazy(()=> import("./examples/Link-with-Truncation"));
const Listwithdetails = lazy(()=> import("./examples/List-with-details"));
const MediaCardExample = lazy(()=> import("./examples/Media-Card-Example"));
const MegaDateTimePicker = lazy(()=> import("./examples/Mega-Date-Time-Picker"));
const MultiAutocompletewithChipStyling = lazy(()=> import("./examples/Multi-Autocomplete-with-Chip-Styling"));
const MultiSelectChipCustomBase = lazy(()=> import("./examples/MultiSelectChip-Custom-Base"));
const MultiSelectChipScrollBehavior = lazy(()=> import("./examples/MultiSelectChip-Scroll-Behavior"));
const MultiSelectChipwithDisabledValues = lazy(()=> import("./examples/MultiSelectChip-with-Disabled-Values"));
const MultipleRadioGroups = lazy(()=> import("./examples/Multiple-Radio-Groups"));
const MultiselectChipHideSelectAll = lazy(()=> import("./examples/Multiselect-Chip-Hide-Select-All"));
const MultiselectDropdownGroupList = lazy(()=> import("./examples/Multiselect-Dropdown-Group-List"));
const NavigationLeftMenuSimple = lazy(()=> import("./examples/Navigation-Left-Menu-Simple"));
const NavigationLeftMenuwithlogoandicons = lazy(()=> import("./examples/Navigation-Left-Menu-with-logo-and-icons"));
const NavigationMenuProductSwitcherasHomeButton = lazy(()=> import("./examples/Navigation-Menu-Product-Switcher-as-Home-Button"));
const NavigationMenuWithBadges = lazy(()=> import("./examples/Navigation-Menu-With-Badges"));
const NumberIncrementer = lazy(()=> import("./examples/Number-Incrementer"));
const PageHeaderCta = lazy(()=> import("./examples/Page-Header-Cta"));
const PageHeaderNavigationTabsLayout = lazy(()=> import("./examples/Page-Header-Navigation-Tabs-Layout"));
const PageHeaderTitlewithButtons = lazy(()=> import("./examples/Page-Header-Title-with-Buttons"));
const PageHeaderWithLink = lazy(()=> import("./examples/Page-Header-With-Link"));
const PopupAsContextMenu = lazy(()=> import("./examples/Popup-As-Context-Menu"));
const RadioButtonwithColor = lazy(()=> import("./examples/Radio-Button-with-Color"));
const ReactRouterExample = lazy(()=> import("./examples/React-Router-Example"));
const Responsivedropdowns = lazy(()=> import("./examples/Responsive-dropdowns"));
const SelectChipMenu = lazy(()=> import("./examples/Select-Chip-Menu"));
const ShowingAutofocusForButtons = lazy(()=> import("./examples/Showing-Autofocus-For-Buttons"));
const SimpleSimpleTable = lazy(()=> import("./examples/Simple-Simple-Table"));
const SimpleSimpleTableColumnShowHide = lazy(()=> import("./examples/Simple-Simple-Table-Column-Show-Hide"));
const SimpleSimpleTableStickyFooter = lazy(()=> import("./examples/Simple-Simple-Table-Sticky-Footer"));
const SimpleSimpleTablewithSearch = lazy(()=> import("./examples/Simple-Simple-Table-with-Search"));
const SimpleSimpleTablewithSearchHighlightPaginationSort = lazy(()=> import("./examples/Simple-Simple-Table-with-Search-Highlight-Pagination-Sort"));
const SimpleTableExpandingRows = lazy(()=> import("./examples/Simple-Table-Expanding-Rows"));
const SimpleTableSorting = lazy(()=> import("./examples/Simple-Table-Sorting"));
const SingleImageUploader = lazy(()=> import("./examples/Single-Image-Uploader"));
const SkeletonLoaderFullPage = lazy(()=> import("./examples/Skeleton-Loader-Full-Page"));
const SliderValidation = lazy(()=> import("./examples/Slider-Validation"));
const Tabsquestion = lazy(()=> import("./examples/Tabs-question"));
const TooltipinDialog = lazy(()=> import("./examples/Tooltip-in-Dialog"));
const TooltiplikeHoverforImages = lazy(()=> import("./examples/Tooltip-like-Hover-for-Images"));
const YearRangePicker = lazy(()=> import("./examples/Year-Range-Picker"));
const DevreviewDateRangeChipPreselect = lazy(()=> import("./examples/devreview/Date-Range-Chip-Pre-select"));
const HiddenCRMLayout = lazy(()=> import("./examples/hidden/CRM-Layout"));
const HiddenDatePickerDatePIckerdevelopment = lazy(()=> import("./examples/hidden/DatePicker/DatePIcker-development"));
const HiddenDatePickerwithInfo = lazy(()=> import("./examples/hidden/DatePicker-with-Info"));
const HiddenFormattedInputExample = lazy(()=> import("./examples/hidden/Formatted-Input-Example"));
const HiddenImageUploader = lazy(()=> import("./examples/hidden/Image-Uploader"));
const HiddenJournalEntry = lazy(()=> import("./examples/hidden/Journal-Entry"));
const HiddenReusabledropdowns = lazy(()=> import("./examples/hidden/Reusable-dropdowns"));
const HiddenTileiconexample = lazy(()=> import("./examples/hidden/Tile-icon-example"));
const HiddenaddressAddressComponent = lazy(()=> import("./examples/hidden-address/Address-Component"));
const HiddenautocompleteAutocompleteWithButton = lazy(()=> import("./examples/hidden-autocomplete/Autocomplete-With-Button"));
const HiddenfolderuiFolderLikeItemDetailListing = lazy(()=> import("./examples/hidden-folder-ui/Folder-Like-Item-Detail-Listing"));
const HiddennestedtableforjoeyNestedRowsWorkflows = lazy(()=> import("./examples/hidden-nested-table-for-joey/Nested-Rows-Workflows"));
const HiddenpoAccountingpoprototype = lazy(()=> import("./examples/hidden-po/Accounting-po-prototype"));
const MikeysAmazingTestPlaygroundCSSGridLayout = lazy(()=> import("./examples/mikeysAmazingTestPlayground/CSS-Grid-Layout"));
const MikeysAmazingTestPlaygroundColorthemeslideroverride = lazy(()=> import("./examples/mikeysAmazingTestPlayground/Color-theme-slider-override"));
const MikeysAmazingTestPlaygroundDRPariadisabledtest = lazy(()=> import("./examples/mikeysAmazingTestPlayground/DRP-aria-disabled-test"));
const MikeysAmazingTestPlaygroundEditableInputPOC = lazy(()=> import("./examples/mikeysAmazingTestPlayground/Editable-Input-POC"));
const MikeysAmazingTestPlaygroundEntertoFocusonNextInput = lazy(()=> import("./examples/mikeysAmazingTestPlayground/Enter-to-Focus-on-Next-Input"));
const MikeysAmazingTestPlaygroundIndeterminateCircleLoader = lazy(()=> import("./examples/mikeysAmazingTestPlayground/Indeterminate-Circle-Loader"));
const MikeysAmazingTestPlaygroundInputTextColorTest = lazy(()=> import("./examples/mikeysAmazingTestPlayground/Input-Text-Color-Test"));
const MikeysAmazingTestPlaygroundLocalAutocomplete = lazy(()=> import("./examples/mikeysAmazingTestPlayground/Local-Autocomplete"));
const MikeysAmazingTestPlaygroundMultiSelectChipwithnoClearButton = lazy(()=> import("./examples/mikeysAmazingTestPlayground/MultiSelectChip-with-no-Clear-Button"));
const MikeysAmazingTestPlaygroundNavigationMenuV2withlongnames = lazy(()=> import("./examples/mikeysAmazingTestPlayground/Navigation-Menu-V2-with-long-names"));
const MikeysAmazingTestPlaygroundPdfViewer = lazy(()=> import("./examples/mikeysAmazingTestPlayground/Pdf-Viewer"));
const MikeysAmazingTestPlaygroundSimpleAutocompletePOC = lazy(()=> import("./examples/mikeysAmazingTestPlayground/Simple-Autocomplete-POC"));
const MikeysAmazingTestPlaygroundSimpleSimpleTablewithdisabledrow = lazy(()=> import("./examples/mikeysAmazingTestPlayground/Simple-Simple-Table-with-disabled-row"));
const MikeysAmazingTestPlaygroundSingleSelectDropdown = lazy(()=> import("./examples/mikeysAmazingTestPlayground/Single-Select-Dropdown"));
const MikeysAmazingTestPlaygroundTableHeaderTitleWithIcon = lazy(()=> import("./examples/mikeysAmazingTestPlayground/Table-Header-Title-With-Icon"));
const MikeysAmazingTestPlaygroundTooltipissue = lazy(()=> import("./examples/mikeysAmazingTestPlayground/Tooltip-issue"));
const MikeysAmazingTestPlaygroundpi1Demo = lazy(()=> import("./examples/mikeysAmazingTestPlayground/pi1-Demo"));
const PetersplaygroundCustomAutocompleteCheckboxes = lazy(()=> import("./examples/peters-playground/Custom-Autocomplete-Checkboxes"));
const PetersplaygroundSidesheetExampleOutsideClick = lazy(()=> import("./examples/peters-playground/Sidesheet-Example-Outside-Click"));
const PocenterastabEnterAsTab = lazy(()=> import("./examples/poc-enter-as-tab/Enter-As-Tab"));
const SupportquestionsDatePickerSelectTyping = lazy(()=> import("./examples/support-questions/DatePicker-Select-Typing"));

export const routes = [ 
"/devreview",
"/hidden",
"/hidden/DatePicker",
"/hidden-address",
"/hidden-autocomplete",
"/hidden-folder-ui",
"/hidden-nested-table-for-joey",
"/hidden-po",
"/mikeysAmazingTestPlayground",
"/peters-playground",
"/poc-enter-as-tab",
"/support-questions" 
];

const examples = [ 
{ id: '/Accordion-Chevron-Left',
name: 'Accordion with Left Chevron',
description: 'Use styled-components to move the open/close chevron to the left instead of the right.',
tags: ["Accordion","Styling","CSS"],
created: 'July 10, 2024',
modified: 'July 10, 2024',
path: '/Accordion-Chevron-Left',
component: <AccordionChevronLeft/>
},
{ id: '/Accordion-with-styling',
name: 'Accordion with Styling',
description: 'Putting border, color, and text alignment on an accordion panel',
tags: ["Accordion","Simple Accordion","Status Indicator"],
created: 'April 30, 2024',
modified: 'April 30, 2024',
path: '/Accordion-with-styling',
component: <Accordionwithstyling/>
},
{ id: '/Autocomplete-Option-Not-on-List',
name: 'Access to Autocomplete Option not on the Dropdown List',
description: 'Testing to see if devs have access to whatever is typed in the list, irrespective of whether the value is on the list',
tags: ["Autocomplete"],
created: 'August 10, 2023',
modified: 'August 11, 2023',
path: '/Autocomplete-Option-Not-on-List',
component: <AutocompleteOptionNotonList/>
},
{ id: '/Button-Disabled-with-Tooltip',
name: 'Tooltip Options for Disabled Buttons',
description: 'What you can do if you need to give the user visual feedback when buttons are disabled',
tags: ["Button","Tooltip"],
created: 'July 31, 2023',
modified: 'October 17, 2023',
path: '/Button-Disabled-with-Tooltip',
component: <ButtonDisabledwithTooltip/>
},
{ id: '/Button-Trailing-Icon',
name: 'Button with trailing icon',
description: 'Radial does not support trailing icons in  buttons, but you can make it with a little CSS.',
tags: ["button","icon","styled components"],
created: 'August 30, 2022',
modified: 'October 18, 2023',
path: '/Button-Trailing-Icon',
component: <ButtonTrailingIcon/>
},
{ id: '/Composed-Page-Header-Overflow-Menu',
name: 'Composed Page Header Overflow Button',
description: 'How to recreate the deprecated PageHeaderButtonOverflowMenu using RDS Menu in a composable manner.',
tags: ["Context Menu","Menu","Button","Deprecation Help","Composed","Page Header","Page Header Button Overflow Menu"],
created: 'September 12, 2022',
modified: 'September 6, 2023',
path: '/Composed-Page-Header-Overflow-Menu',
component: <ComposedPageHeaderOverflowMenu/>
},
{ id: '/Conditional-Menu',
name: 'Conditional Menu Example',
description: 'An example of a button that renders a menu only if a condition has been met.',
tags: ["Menu"],
created: 'July 25, 2022',
modified: 'July 27, 2022',
path: '/Conditional-Menu',
component: <ConditionalMenu/>
},
{ id: '/Currency-Input-Custom-Handler',
name: 'Currency Input for assumed decimal aka, Accounting Currency Input',
description: 'This input assumes two decimal points, unless a decimal is part of the input. 100 = 1.00, 1000 = 10.00, 1. = 1.00',
tags: ["Currency Input","Accounting"],
created: 'September 20, 2022',
modified: 'October 10, 2022',
path: '/Currency-Input-Custom-Handler',
component: <CurrencyInputCustomHandler/>
},
{ id: '/Custom-Button-Color',
name: 'Custom Button Colors',
description: 'This is not recommended, but if you absolutely have to do it, this is how to use styled-components to change button color.',
tags: ["button","color","styled components"],
created: 'September 26, 2022',
modified: 'September 26, 2022',
path: '/Custom-Button-Color',
component: <CustomButtonColor/>
},
{ id: '/Custom-Hideable-Input',
name: 'Custom Hideable Input',
description: 'There is something odd in the RDS HideableInput that is not working with spaces and other characters. Luckily, RDS is felxible enough to build a new one using existing components.',
tags: ["Input","Hideable Input"],
created: 'September 26, 2023',
modified: 'September 26, 2023',
path: '/Custom-Hideable-Input',
component: <CustomHideableInput/>
},
{ id: '/Custom-Multi-Select-Chip-with-Search-and-Keyboard-Handling',
name: 'Custom Multi Select Menu with Search and Keyboard Handling',
description: 'A container that allows searching of multi select menu options, with included \"Radial\" keyboard handling',
tags: ["Chip","Proof of Concept","MultiSelect","Custom Menu","CardWrapper","Menu List Items"],
created: 'June 3, 2024',
modified: 'June 3, 2024',
path: '/Custom-Multi-Select-Chip-with-Search-and-Keyboard-Handling',
component: <CustomMultiSelectChipwithSearchandKeyboardHandling/>
},
{ id: '/Custom-Single-Select-Chip-with-Search',
name: 'Custom Single Select Menu Chip with Search',
description: 'A container that allows searching of single select menu options',
tags: ["Chip","Menu","Proof of Concept","Menu List Item"],
created: 'May 7, 2024',
modified: 'May 7, 2024',
path: '/Custom-Single-Select-Chip-with-Search',
component: <CustomSingleSelectChipwithSearch/>
},
{ id: '/Data-Server-Example',
name: 'Paginated Data using Radial\'s Mock Data Server',
description: 'howing how to use Radial Park\'s internal "data server" routines to help with things like paginated data.',
tags: ["table","data","card","pagination"],
created: 'January 17, 2023',
modified: 'January 17, 2023',
path: '/Data-Server-Example',
component: <DataServerExample/>
},
{ id: '/Date-Picker-Custom-Shortcut-Chips',
name: 'Custom Shortcut Chips in DatePickers',
description: 'How to create custom shortcut chips using a custom DatePicker',
tags: ["Date Picker","Pickers"],
created: 'December 20, 2023',
modified: 'December 20, 2023',
path: '/Date-Picker-Custom-Shortcut-Chips',
component: <DatePickerCustomShortcutChips/>
},
{ id: '/Date-Picker-Positioning',
name: 'Date Picker Positioning',
description: 'Ways to position the date picker dropdown with Styled Components',
tags: ["Pickers","Date Picker","Date Range Picker","Positioning"],
created: 'December 20, 2023',
modified: 'December 20, 2023',
path: '/Date-Picker-Positioning',
component: <DatePickerPositioning/>
},
{ id: '/Date-Picker-flexibleDateInput',
name: 'Date Pickers with Flexible Date Input Shortcuts',
description: 'Showcasing the new ways to use RDS DatePickers with the `flexibleDateInput` prop',
tags: ["Pickers","Date Picker","Date Range Picker","flexible date input"],
created: 'February 21, 2024',
modified: 'February 21, 2024',
path: '/Date-Picker-flexibleDateInput',
component: <DatePickerflexibleDateInput/>
},
{ id: '/Date-Range-Picker-Auto-Select',
name: 'Auto Selecting a Date Range with Date Range Picker',
description: 'This example shows how to auto select the next 7 days based upon Start Date selection.',
tags: ["Date Range Picker","Date Picker"],
created: 'November 15, 2022',
modified: 'November 15, 2022',
path: '/Date-Range-Picker-Auto-Select',
component: <DateRangePickerAutoSelect/>
},
{ id: '/Date-Range-Picker-Reset',
name: 'Reset Date Range Picker, end date',
description: 'How to reset Start or End dates by setting them to null',
tags: ["date picker","date range picker"],
created: 'October 19, 2022',
modified: 'October 19, 2023',
path: '/Date-Range-Picker-Reset',
component: <DateRangePickerReset/>
},
{ id: '/Dialog-Hide-Overlay',
name: 'Dialog with Hidden Overlay',
description: 'A way to hide the overlay scrim in a Dialog component',
tags: ["Dialog","Dialog Overlay","Overlay","Scrim"],
created: 'November 15, 2023',
modified: 'November 16, 2023',
path: '/Dialog-Hide-Overlay',
component: <DialogHideOverlay/>
},
{ id: '/Dialog-with-Pagination',
name: 'Dialog with Pagination',
description: 'How to get the pagination page size dropdown to properly display',
tags: ["Dialog","Pagination","z-index","Dropdown"],
created: 'October 3, 2023',
modified: 'October 3, 2023',
path: '/Dialog-with-Pagination',
component: <DialogwithPagination/>
},
{ id: '/Dialog-with-Sticky-Content',
name: 'Dialog with Sticky Content',
description: 'A way to use an RDS Dialog with sticky content at the top',
tags: ["Dialog","Sticky"],
created: 'June 6, 2024',
modified: 'June 6, 2024',
path: '/Dialog-with-Sticky-Content',
component: <DialogwithStickyContent/>
},
{ id: '/Dialog-with-a-Datepicker',
name: 'Dialog with a Datepicker',
description: 'An example of how to display a datepicker calendar in a dialog.',
tags: ["Dialog","Date picker","Pickers"],
created: 'February 27, 2023',
modified: 'February 27, 2023',
path: '/Dialog-with-a-Datepicker',
component: <DialogwithaDatepicker/>
},
{ id: '/Dialog-with-dropdown',
name: 'Dialog with Dropdown Menu',
description: 'An example of how to use a dropdown menu in a dialog with the help of portal.',
tags: ["Dialog","Dropdown","Menu","Z-index","Portal"],
created: 'July 6, 2022',
modified: 'October 16, 2023',
path: '/Dialog-with-dropdown',
component: <Dialogwithdropdown/>
},
{ id: '/Dialog-with-inputs',
name: 'Dialog with Inputs',
description: 'Example to show how to update inputs in a dialog and update main page on save.',
tags: ["dialog","input"],
created: 'August 11, 2022',
modified: 'September 12, 2022',
path: '/Dialog-with-inputs',
component: <Dialogwithinputs/>
},
{ id: '/Dialogs-With-Dropdowns',
name: 'Dialog chaining with Dropdowns',
description: 'A complex flow involving multiple dialogs and dropdowns',
tags: ["dialog","dropdown"],
created: 'March 14, 2023',
modified: 'October 13, 2023',
path: '/Dialogs-With-Dropdowns',
component: <DialogsWithDropdowns/>
},
{ id: '/Dropdown-Composed-Menu-Width',
name: 'Dropdown - Composed Menu with dynamic menu width',
description: 'The dropdown menu width adjusts based on the length of the options',
tags: ["Dropdown","Menu","Composed","Width"],
created: 'July 8, 2022',
modified: 'October 16, 2023',
path: '/Dropdown-Composed-Menu-Width',
component: <DropdownComposedMenuWidth/>
},
{ id: '/Dropdown-Custom-Input',
name: 'Custom Dropdown Input',
description: 'Two line option/dropdown',
tags: ["Dropdown","Custom"],
created: 'December 19, 2024',
modified: 'December 24, 2024',
path: '/Dropdown-Custom-Input',
component: <DropdownCustomInput/>
},
{ id: '/Dropdown-Menu-Width',
name: 'Dropdown - setting the menu width',
description: 'By default the Composed Dropdown menu width is fixed. This example shows how to set it to \'fit-content\' or to match the width of the Input.',
tags: ["Dropdown","Menu","width"],
created: 'October 23, 2022',
modified: 'October 19, 2023',
path: '/Dropdown-Menu-Width',
component: <DropdownMenuWidth/>
},
{ id: '/Editable-Title',
name: 'Editable Page Header Title',
description: 'Wrapping EditableText in a Page Header Title to make the title editable',
tags: ["Page Header","Page Header Title","Editable Text"],
created: 'February 20, 2025',
modified: 'February 20, 2025',
path: '/Editable-Title',
component: <EditableTitle/>
},
{ id: '/Error-Example',
name: '404 Error Page Example',
description: 'This is a full example of how to build a responsive 404 error page.',
tags: ["Not Found 404","Error Page","animation","svg"],
created: 'June 21, 2022',
modified: 'July 8, 2022',
path: '/Error-Example',
component: <ErrorExample/>
},
{ id: '/Filter-Chips-With-Color-Swatches',
name: 'Filter Chips with Color Swatches',
description: 'How to add an element in-between the checkbox and label of a FilterChip.',
tags: ["Filter Chip","Icon"],
created: 'November 25, 2023',
modified: 'November 25, 2023',
path: '/Filter-Chips-With-Color-Swatches',
component: <FilterChipsWithColorSwatches/>
},
{ id: '/Flatten-Nested-Object',
name: 'Flatten Nested Object for Dropdown',
description: 'The Menu component in a Dropdown needs a flat array for the options.',
tags: ["dropdown","nested object","menu","menu List Item","avatar","Proof of Concept"],
created: 'November 16, 2022',
modified: 'October 18, 2023',
path: '/Flatten-Nested-Object',
component: <FlattenNestedObject/>
},
{ id: '/Fortellis-Theme',
name: 'Fortellis Theme',
description: 'How to assemble and override the Fortellis Theme object',
tags: ["Fortellis","theme"],
created: 'August 16, 2023',
modified: 'August 16, 2023',
path: '/Fortellis-Theme',
component: <FortellisTheme/>
},
{ id: '/Full-screen-loader',
name: 'Full Screen Loader',
description: 'Three examples of full screen loader overlays.',
tags: ["loader","indeterminate progress circle","determinate progress circle"],
created: 'August 9, 2022',
modified: 'December 1, 2023',
path: '/Full-screen-loader',
component: <Fullscreenloader/>
},
{ id: '/GroupList-Example',
name: 'GroupList Example',
description: 'How to make a Dropdown with MenuListGroupItem.',
tags: ["dropdown","group list","custom styles"],
created: 'September 7, 2022',
modified: 'September 15, 2022',
path: '/GroupList-Example',
component: <GroupListExample/>
},
{ id: '/Input-Chip-Error-Handling',
name: 'Required Input Chips Custom Error Validation',
description: 'A way to properly use InputChips with custom error validation',
tags: ["Input Chips","Validation","Error handling"],
created: 'January 17, 2025',
modified: 'January 17, 2025',
path: '/Input-Chip-Error-Handling',
component: <InputChipErrorHandling/>
},
{ id: '/Input-Chips-Custom-Validation',
name: 'InputChips Custom Validation',
description: 'How to validate the number of required chips for an InputChips component.',
tags: ["chips","input chips","Validation"],
created: 'March 16, 2023',
modified: 'March 16, 2023',
path: '/Input-Chips-Custom-Validation',
component: <InputChipsCustomValidation/>
},
{ id: '/Input-Error-Validation',
name: 'Input Error Validation with Simulated API Validation Call',
description: 'Simulating an API call to validate an Input value.',
tags: ["Validation","Input"],
created: 'December 15, 2022',
modified: 'October 17, 2023',
path: '/Input-Error-Validation',
component: <InputErrorValidation/>
},
{ id: '/Input-error-icon-color',
name: 'Input error icon color',
description: 'When an Input is in an error state, and that Input has an icon, the icon will be red.',
tags: ["icon","color","error","input"],
created: 'June 15, 2022',
modified: 'October 18, 2023',
path: '/Input-error-icon-color',
component: <Inputerroriconcolor/>
},
{ id: '/Link-Keyboard-Navigation',
name: 'Link Keyboard Navigation Test',
description: 'Making sure the RDS Link component handles keyboard navigation properly',
tags: ["Link"],
created: 'November 29, 2023',
modified: 'November 29, 2023',
path: '/Link-Keyboard-Navigation',
component: <LinkKeyboardNavigation/>
},
{ id: '/Link-with-Truncation',
name: 'Link with TitleOnTruncate',
description: 'This is an example of how to style an html anchor link to look and feel like an RDS Link and use truncation handling with it',
tags: ["Link","Truncation Handling"],
created: 'September 16, 2024',
modified: 'September 16, 2024',
path: '/Link-with-Truncation',
component: <LinkwithTruncation/>
},
{ id: '/List-with-details',
name: 'List with details',
description: 'Built out a custom Message component example.',
tags: ["Proof of Concept","list"],
created: 'June 28, 2022',
modified: 'July 27, 2022',
path: '/List-with-details',
component: <Listwithdetails/>
},
{ id: '/Media-Card-Example',
name: 'Composed Media Card Example (with some Truncation Handling)',
description: 'An example of how to use the RDS Card elements and blocks to compose a Media Card.',
tags: ["Media Card","Card","Composed","Deprecation Help","Truncation Handling"],
created: 'October 11, 2022',
modified: 'October 13, 2022',
path: '/Media-Card-Example',
component: <MediaCardExample/>
},
{ id: '/Mega-Date-Time-Picker',
name: 'Mega Date Time Picker Example',
description: 'An example of composed date and time picker that can be used to filter data based on start/end date and time.',
tags: ["Chips","Proof of Concept","Date Picker","Maskable Formatted Input","Pickers","Time Input","Validation"],
created: 'July 14, 2022',
modified: 'August 24, 2022',
path: '/Mega-Date-Time-Picker',
component: <MegaDateTimePicker/>
},
{ id: '/Multi-Autocomplete-with-Chip-Styling',
name: 'Multi-Autocomplete with Chip Styling',
description: 'A way to target the chip styling of the Multi-Autocomplete component',
tags: ["Multi Autocomplete","Styling"],
created: 'May 23, 2023',
modified: 'May 23, 2023',
path: '/Multi-Autocomplete-with-Chip-Styling',
component: <MultiAutocompletewithChipStyling/>
},
{ id: '/MultiSelectChip-Custom-Base',
name: 'MultiSelectChip - Custom Base',
description: 'This is the code for MultiSelectChip. You can customize it to your needs.',
tags: ["MultiSelectChip"],
created: 'November 5, 2024',
modified: 'November 5, 2024',
path: '/MultiSelectChip-Custom-Base',
component: <MultiSelectChipCustomBase/>
},
{ id: '/MultiSelectChip-Scroll-Behavior',
name: 'MultiSelectChip Scroll Behavior',
description: 'An example set up to show how MultiSelectChip closes on outer scroll properly',
tags: ["Multi Select Chip"],
created: 'December 21, 2023',
modified: 'January 11, 2024',
path: '/MultiSelectChip-Scroll-Behavior',
component: <MultiSelectChipScrollBehavior/>
},
{ id: '/MultiSelectChip-with-Disabled-Values',
name: 'MultiSelectChip with Disabled Pre-selected Values',
description: 'One way to keep the pre-selected disabled values intact upon clearing selected values',
tags: ["chips","Multi Select Chip"],
created: 'August 30, 2023',
modified: 'August 31, 2023',
path: '/MultiSelectChip-with-Disabled-Values',
component: <MultiSelectChipwithDisabledValues/>
},
{ id: '/Multiple-Radio-Groups',
name: 'Multiple Radio Groups',
description: 'Checking to see if there are issues when using multiple radio groups on the same page',
tags: ["Radio","Radio Group"],
created: 'January 7, 2025',
modified: 'January 7, 2025',
path: '/Multiple-Radio-Groups',
component: <MultipleRadioGroups/>
},
{ id: '/Multiselect-Chip-Hide-Select-All',
name: 'Hide Select All in MultiSelectChip',
description: 'A way to remove the Select All option in a MultiSelectChip.',
tags: ["chips","Multi Select Chip"],
created: 'January 18, 2023',
modified: 'October 13, 2023',
path: '/Multiselect-Chip-Hide-Select-All',
component: <MultiselectChipHideSelectAll/>
},
{ id: '/Multiselect-Dropdown-Group-List',
name: 'Multiselect Dropdown Group List with Checkboxes',
description: 'Show how to break up a dropdown list using Groups, and allow selections with Checkboxes.',
tags: ["multiselect","Group List","Dropdown","Checkbox"],
created: 'February 7, 2023',
modified: 'February 7, 2023',
path: '/Multiselect-Dropdown-Group-List',
component: <MultiselectDropdownGroupList/>
},
{ id: '/Navigation-Left-Menu-Simple',
name: 'Simple Navigation Menu with Layout',
description: 'A simple example of a composed left navigation menu with Layout.',
tags: ["Composed","Layout","Navigation","Navigation Context Switcher","Navigation Menu"],
created: 'December 4, 2022',
modified: 'December 5, 2023',
path: '/Navigation-Left-Menu-Simple',
component: <NavigationLeftMenuSimple/>
},
{ id: '/Navigation-Left-Menu-with-logo-and-icons',
name: 'Navigation Menu with Layout, CDK logos, and extra button icons',
description: 'A NavigationMenu with a Product Switcher at the top and CDK logo and icons at the bottom of the navigation section, and a sticky footer in the content section',
tags: ["Composed","Layout","Navigation","Navigation Context Switcher","Navigation Menu","Sticky"],
created: 'December 4, 2023',
modified: 'December 5, 2023',
path: '/Navigation-Left-Menu-with-logo-and-icons',
component: <NavigationLeftMenuwithlogoandicons/>
},
{ id: '/Navigation-Menu-Product-Switcher-as-Home-Button',
name: 'Navigation Menu with Product Home Button',
description: 'An example of how to style the Home button, and properly highlight the NavigationMenu on external page view changes.',
tags: ["Composed","Layout","Navigation","Navigation Context Switcher","Navigation Menu"],
created: 'December 5, 2022',
modified: 'December 13, 2023',
path: '/Navigation-Menu-Product-Switcher-as-Home-Button',
component: <NavigationMenuProductSwitcherasHomeButton/>
},
{ id: '/Navigation-Menu-With-Badges',
name: 'Navigation Menu with Badges',
description: 'Using badges with the Navigation Menu icons takes a little bit of work. We made a custom hook to simplify it.',
tags: ["Navigation","Navigation Menu","Badge","Hooks"],
created: 'September 27, 2024',
modified: 'September 27, 2024',
path: '/Navigation-Menu-With-Badges',
component: <NavigationMenuWithBadges/>
},
{ id: '/Number-Incrementer',
name: 'Number Incrementer Proof of Concept',
description: 'Two buttons and an InlineInput designed to step a numeric value up and down',
tags: ["Inline Input","button","Proof of Concept","input","Validation"],
created: 'April 27, 2023',
modified: 'April 28, 2023',
path: '/Number-Incrementer',
component: <NumberIncrementer/>
},
{ id: '/Page-Header-Cta',
name: 'Page Header CTA',
description: 'A Composed Page Header with CTA (Call To Action) Buttons.',
tags: ["Page Header","Button","Page Title With Buttons","Page Header CTA Block","Deprecation Help"],
created: 'September 6, 2023',
modified: 'September 6, 2023',
path: '/Page-Header-Cta',
component: <PageHeaderCta/>
},
{ id: '/Page-Header-Navigation-Tabs-Layout',
name: 'Page Header Navigation Tabs Layout',
description: 'A Composed Page Header with Navigation Tabs and Layout.',
tags: ["Page Header","Navigation","Tabs","Deprecation Help"],
created: 'September 11, 2023',
modified: 'September 11, 2023',
path: '/Page-Header-Navigation-Tabs-Layout',
component: <PageHeaderNavigationTabsLayout/>
},
{ id: '/Page-Header-Title-with-Buttons',
name: 'Page Header Title with Buttons',
description: 'Composed Page Header Title with Buttons and Overflow Button Menu.',
tags: ["Page Header","Menu","Button","Deprecation Help","Composed"],
created: 'September 12, 2022',
modified: 'September 15, 2022',
path: '/Page-Header-Title-with-Buttons',
component: <PageHeaderTitlewithButtons/>
},
{ id: '/Page-Header-With-Link',
name: 'Page Header Composition with Link',
description: 'Using the Page Header block PageHeaderIconLink to compose a PageHeader component.',
tags: ["page header","Page Header Icon Link","link","composed","deprecation help"],
created: 'November 30, 2022',
modified: 'September 12, 2023',
path: '/Page-Header-With-Link',
component: <PageHeaderWithLink/>
},
{ id: '/Popup-As-Context-Menu',
name: 'Popup as Context Menu',
description: 'Need a Context Menu with Inputs that sits in a Dialog header. We\'ll hide the standard dialong header and build a custom one.',
tags: ["popup","context menu","card","dialog","menu","drop down"],
created: 'December 20, 2022',
modified: 'December 27, 2022',
path: '/Popup-As-Context-Menu',
component: <PopupAsContextMenu/>
},
{ id: '/Radio-Button-with-Color',
name: 'Radio Button Groups with Color',
description: 'A way to use styled components to modify Radio Button colors',
tags: ["radio group","radio","styled components"],
created: 'September 15, 2022',
modified: 'September 15, 2022',
path: '/Radio-Button-with-Color',
component: <RadioButtonwithColor/>
},
{ id: '/React-Router-Example',
name: 'Using NavigationMenu with React Router',
description: 'How to listen for the rdsNavMenuSelect event emitted by NavigationMenu on leaf node selection and pass the necessary path to React Router',
tags: ["Navigation Menu","React Router","Custon Events"],
created: 'December 13, 2023',
modified: 'December 13, 2023',
path: '/React-Router-Example',
component: <ReactRouterExample/>
},
{ id: '/Responsive-dropdowns',
name: 'Responsive Dropdowns',
description: 'How Radial components can respond to width changes.',
tags: ["responsive","dropdown","css grid","menu","menu list item"],
created: 'August 11, 2022',
modified: 'August 17, 2022',
path: '/Responsive-dropdowns',
component: <Responsivedropdowns/>
},
{ id: '/Select-Chip-Menu',
name: 'Composed SelectChip with Menu',
description: 'How to build a custom SelectChip component using Chip and Menu. Also how to clear the selection from code.',
tags: ["chips","Select Chip","Menu","composed"],
created: 'November 21, 2022',
modified: 'October 18, 2023',
path: '/Select-Chip-Menu',
component: <SelectChipMenu/>
},
{ id: '/Showing-Autofocus-For-Buttons',
name: 'Button Focus Ring on Page Load',
description: 'The way Buttons handle focus has a side-effect of not showing a focus ring without user interaction. This means trying to focus a Button on page load doesn\'t appear to work, even though the Button is focused. This example shows how to fix that.',
tags: ["button","focus","autofocus","UseRef"],
created: 'March 2, 2023',
modified: 'March 2, 2023',
path: '/Showing-Autofocus-For-Buttons',
component: <ShowingAutofocusForButtons/>
},
{ id: '/Simple-Simple-Table',
name: 'A simple Simple Table',
description: 'A way to use RDS SimpleTable components with just a title, column definitions and table data',
tags: ["Simple Table"],
created: 'October 4, 2023',
modified: 'October 4, 2023',
path: '/Simple-Simple-Table',
component: <SimpleSimpleTable/>
},
{ id: '/Simple-Simple-Table-Column-Show-Hide',
name: 'Simple Table with Column Selection',
description: 'A way to implement Simple Table to give users the option select the columns they wish to hide',
tags: ["Simple Table","Table Column Selection"],
created: 'February 12, 2024',
modified: 'February 12, 2024',
path: '/Simple-Simple-Table-Column-Show-Hide',
component: <SimpleSimpleTableColumnShowHide/>
},
{ id: '/Simple-Simple-Table-Sticky-Footer',
name: 'A simple Simple Table with Sticky Footer and Cell Alignment',
description: 'RDS SimpleTable with cell content alignment and a sticky footer',
tags: ["Simple Table","Sticky","Column Alignment"],
created: 'October 16, 2023',
modified: 'October 16, 2023',
path: '/Simple-Simple-Table-Sticky-Footer',
component: <SimpleSimpleTableStickyFooter/>
},
{ id: '/Simple-Simple-Table-with-Search',
name: 'Simple Table with Search and Highlight',
description: 'A way to wire up RDS SimpleTable with Search with Highlighted Search Values',
tags: ["Simple Table","Proof of Concept","search","highlight"],
created: 'February 8, 2024',
modified: 'February 8, 2024',
path: '/Simple-Simple-Table-with-Search',
component: <SimpleSimpleTablewithSearch/>
},
{ id: '/Simple-Simple-Table-with-Search-Highlight-Pagination-Sort',
name: 'Simple Table with Search, Highlight, Pagination, and Column Sorting',
description: 'A not so simple RDS Simple Table wired with Sticky header, sticky pagination, search, highlight and column sorting',
tags: ["Simple Table","search","highlight","pagination","sort"],
created: 'February 9, 2024',
modified: 'February 10, 2024',
path: '/Simple-Simple-Table-with-Search-Highlight-Pagination-Sort',
component: <SimpleSimpleTablewithSearchHighlightPaginationSort/>
},
{ id: '/Simple-Table-Expanding-Rows',
name: 'Simple Table with Expanding Rows',
description: 'A version of expanding rows that maintains the column structure in the detail rows.',
tags: ["simple table","expanding rows"],
created: 'January 23, 2023',
modified: 'January 23, 2023',
path: '/Simple-Table-Expanding-Rows',
component: <SimpleTableExpandingRows/>
},
{ id: '/Simple-Table-Sorting',
name: 'SimpleTable with Sort and Pagination',
description: 'Adding sorting with icons showig the current sort to SimpleTable.',
tags: ["simple table","pagination","sorting"],
created: 'March 17, 2023',
modified: 'March 17, 2023',
path: '/Simple-Table-Sorting',
component: <SimpleTableSorting/>
},
{ id: '/Single-Image-Uploader',
name: 'Single Image Uploader',
description: 'An example of how to build an image uploader with Radial Avatar, Dialog, and React Easy Crop',
tags: ["Avatar","Dialog","Primary Button","Text Button","Image Uploader","Slider","React Easy Crop"],
created: 'July 15, 2022',
modified: 'August 9, 2022',
path: '/Single-Image-Uploader',
component: <SingleImageUploader/>
},
{ id: '/Skeleton-Loader-Full-Page',
name: 'Skeleton Loader on Full Page',
description: 'Showcasing Skeleton Loader flexibility by simulating a full page in its loading state.',
tags: ["Skeleton Loader","Page Header"],
created: 'September 27, 2022',
modified: 'February 7, 2023',
path: '/Skeleton-Loader-Full-Page',
component: <SkeletonLoaderFullPage/>
},
{ id: '/Slider-Validation',
name: 'Slider Number Input Validation',
description: 'One way to validate the RDS Slider component input field.',
tags: ["Slider","Validation"],
created: 'January 24, 2023',
modified: 'October 17, 2023',
path: '/Slider-Validation',
component: <SliderValidation/>
},
{ id: '/Tabs-question',
name: 'Tabs Question from Slack',
description: 'Trying to test what Tabs look like on a tablet.',
tags: ["tabs"],
created: 'November 10, 2022',
modified: 'November 10, 2022',
path: '/Tabs-question',
component: <Tabsquestion/>
},
{ id: '/Tooltip-in-Dialog',
name: 'Using a Tooltip in a Dialog',
description: 'Demonstrating how a tooltip will display inside a dialog.',
tags: ["tooltip","dialog","z-index"],
created: 'November 17, 2022',
modified: 'October 13, 2023',
path: '/Tooltip-in-Dialog',
component: <TooltipinDialog/>
},
{ id: '/Tooltip-like-Hover-for-Images',
name: 'Tooltip-like Hover with the Menu Component',
description: 'Tooltips are meant for short amounts of text. Sometimes you need something else, like an image in a hover state.',
tags: ["menu","tooltip","hover"],
created: 'November 21, 2022',
modified: 'November 21, 2022',
path: '/Tooltip-like-Hover-for-Images',
component: <TooltiplikeHoverforImages/>
},
{ id: '/Year-Range-Picker',
name: 'Year Range Picker Proof of Concept',
description: 'One way to use Radial components to create a Year Range Picker',
tags: ["Picker","Year Range Picker","Proof of Concept"],
created: 'January 20, 2023',
modified: 'January 20, 2023',
path: '/Year-Range-Picker',
component: <YearRangePicker/>
},
{ id: '/devreview/Date-Range-Chip-Pre-select',
name: 'Date Range Chip - pre-selecting dates',
description: 'Proof of concept, work in progress.',
tags: ["chips","date range picker","date range picker chips","pickers"],
created: 'December 21, 2022',
modified: 'December 21, 2022',
path: '/devreview/Date-Range-Chip-Pre-select',
route: '/devreview',
component: <DevreviewDateRangeChipPreselect/>
},
{ id: '/hidden/CRM-Layout',
name: 'CRM Opportunity Details Page',
description: 'An example of how to build an entire page.',
tags: ["crm","layout"],
created: 'July 1, 2022',
modified: 'July 1, 2022',
path: '/hidden/CRM-Layout',
route: '/hidden',
component: <HiddenCRMLayout/>
},
{ id: '/hidden/DatePicker/DatePIcker-development',
name: 'DatePicker Development',
description: 'Making a new DatePicker from the ground up.',
tags: ["date","Date Picker","custom"],
created: 'June 22, 2022',
modified: 'June 22, 2022',
path: '/hidden/DatePicker/DatePIcker-development',
route: '/hidden/DatePicker',
component: <HiddenDatePickerDatePIckerdevelopment/>
},
{ id: '/hidden/DatePicker-with-Info',
name: 'DatePicker with prop renderCalendarInfo',
description: 'Proof of concept.',
tags: ["date picker","Info"],
created: 'June 15, 2022',
modified: 'June 15, 2022',
path: '/hidden/DatePicker-with-Info',
route: '/hidden',
component: <HiddenDatePickerwithInfo/>
},
{ id: '/hidden/Formatted-Input-Example',
name: 'Formatted Input - FindDOMNode error fix',
description: 'WIP Showing a known issue - the error you get in strict mode with Formatted Inputs.',
tags: ["Input","Formatted Input","Find DOM Node","WIP"],
created: 'October 8, 2022',
modified: 'October 10, 2022',
path: '/hidden/Formatted-Input-Example',
route: '/hidden',
component: <HiddenFormattedInputExample/>
},
{ id: '/hidden/Image-Uploader',
name: 'Image Uploader',
description: 'An example of how to build an image uploader with Radial Dialog, DropZone, and React Easy Crop.',
tags: ["Dialog","Primary Button","Secondary Button","DropZone","React Easy Crop"],
created: 'July 15, 2022',
modified: 'July 15, 2022',
path: '/hidden/Image-Uploader',
route: '/hidden',
component: <HiddenImageUploader/>
},
{ id: '/hidden/Journal-Entry',
name: 'Journal Entry',
description: 'Kenzie\'s Journal Entry page.',
tags: ["journal entry","table","page","accounting"],
created: 'July 7, 2022',
modified: 'July 7, 2022',
path: '/hidden/Journal-Entry',
route: '/hidden',
component: <HiddenJournalEntry/>
},
{ id: '/hidden/Reusable-dropdowns',
name: 'Making Reusable Dropdowns',
description: 'The composable design of our Dropdowns allows them to be flexible, but it\'s not necessarily obvious how to make reusable components for your application.',
tags: ["menu","dropdown","lists with groups"],
created: 'August 24, 2022',
modified: 'August 24, 2022',
path: '/hidden/Reusable-dropdowns',
route: '/hidden',
component: <HiddenReusabledropdowns/>
},
{ id: '/hidden/Tile-icon-example',
name: 'Examples of the new Product Tile Icons',
description: 'Proof of concept.',
tags: ["icon","product tile","branding","tool"],
created: 'July 29, 2022',
modified: 'July 29, 2022',
path: '/hidden/Tile-icon-example',
route: '/hidden',
component: <HiddenTileiconexample/>
},
{ id: '/hidden-address/Address-Component',
name: 'Address Component',
description: 'A standard address block. Fields can be excluded and layout can be customized with CSS.',
tags: ["Address","custom hook","standard"],
created: 'March 28, 2023',
modified: 'April 11, 2023',
path: '/hidden-address/Address-Component',
route: '/hidden-address',
component: <HiddenaddressAddressComponent/>
},
{ id: '/hidden-autocomplete/Autocomplete-With-Button',
name: 'Autocomplete With Button',
description: 'This is an attempt to put a button at the end of an Autocomplete menu. It works, but because the button is positioned with "sticky" it is removed from the layout. This allows other menu items to receive focus when they are hidden behind the button.',
tags: ["autocomplete"],
created: 'March 13, 2023',
modified: 'March 13, 2023',
path: '/hidden-autocomplete/Autocomplete-With-Button',
route: '/hidden-autocomplete',
component: <HiddenautocompleteAutocompleteWithButton/>
},
{ id: '/hidden-folder-ui/Folder-Like-Item-Detail-Listing',
name: 'Folder-like Listing of Items with Settings',
description: 'This is kind of like a Mac Finder Column View.',
tags: ["List","Folder","Custom Component"],
created: 'August 3, 2023',
modified: 'August 3, 2023',
path: '/hidden-folder-ui/Folder-Like-Item-Detail-Listing',
route: '/hidden-folder-ui',
component: <HiddenfolderuiFolderLikeItemDetailListing/>
},
{ id: '/hidden-nested-table-for-joey/Nested-Rows-Workflows',
name: 'Nested Rows - Workflows for Unify',
description: 'Simple Table Nested Rows for Unify',
tags: ["Simple Table","Template","nested rows"],
created: 'November 30, 2022',
modified: 'November 30, 2022',
path: '/hidden-nested-table-for-joey/Nested-Rows-Workflows',
route: '/hidden-nested-table-for-joey',
component: <HiddennestedtableforjoeyNestedRowsWorkflows/>
},
{ id: '/hidden-po/Accounting-po-prototype',
name: 'Purchase Order Prototype',
description: 'Testing out Ashley\'s design.',
tags: ["accounting","po","prototype"],
created: 'August 24, 2022',
modified: 'August 24, 2022',
path: '/hidden-po/Accounting-po-prototype',
route: '/hidden-po',
component: <HiddenpoAccountingpoprototype/>
},
{ id: '/mikeysAmazingTestPlayground/CSS-Grid-Layout',
name: 'RDS Layout using only css-grid',
description: 'An experiment to create RDS application layout without RDS Layout components - just css-grid',
tags: ["Layout","CSS Grid"],
created: 'May 8, 2024',
modified: 'May 8, 2024',
path: '/mikeysAmazingTestPlayground/CSS-Grid-Layout',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundCSSGridLayout/>
},
{ id: '/mikeysAmazingTestPlayground/Color-theme-slider-override',
name: 'Customizing the Theme Color',
description: 'A way to personalize a user theme with an RDS Slider, which changes the Primary Color Palette',
tags: ["theme","color","slider"],
created: 'February 21, 2024',
modified: 'February 23, 2024',
path: '/mikeysAmazingTestPlayground/Color-theme-slider-override',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundColorthemeslideroverride/>
},
{ id: '/mikeysAmazingTestPlayground/DRP-aria-disabled-test',
name: 'Testing Aria Labeling for Disabled Dates in Date Range Picker Chip',
description: 'Experimenting',
tags: ["Date Range Picker Chip"],
created: 'January 20, 2023',
modified: 'January 20, 2023',
path: '/mikeysAmazingTestPlayground/DRP-aria-disabled-test',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundDRPariadisabledtest/>
},
{ id: '/mikeysAmazingTestPlayground/Editable-Input-POC',
name: 'Editable Input Proof of Concept',
description: 'A Proof of Concept for an Editable Input RDS Component',
tags: ["Proof of Concept","Editable Input"],
created: 'February 13, 2023',
modified: 'February 13, 2023',
path: '/mikeysAmazingTestPlayground/Editable-Input-POC',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundEditableInputPOC/>
},
{ id: '/mikeysAmazingTestPlayground/Enter-to-Focus-on-Next-Input',
name: 'Enter focuses on next Input',
description: 'A way to make and input focus on the next input when the enter key is pressed',
tags: ["Input","Keyboard"],
created: 'July 10, 2024',
modified: 'July 10, 2024',
path: '/mikeysAmazingTestPlayground/Enter-to-Focus-on-Next-Input',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundEntertoFocusonNextInput/>
},
{ id: '/mikeysAmazingTestPlayground/Indeterminate-Circle-Loader',
name: 'IndeterminateCircleLoader - Proof of Concept',
description: 'An Indeterminate Progress Circle with Label and Size capabilities',
tags: ["Indeterminate Progress Circle","Loader","Proof of Concept"],
created: 'October 31, 2023',
modified: 'November 6, 2023',
path: '/mikeysAmazingTestPlayground/Indeterminate-Circle-Loader',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundIndeterminateCircleLoader/>
},
{ id: '/mikeysAmazingTestPlayground/Input-Text-Color-Test',
name: 'Input Placeholder Text Color',
description: 'A way to adjust the placeholder text (but DON\'T...)',
tags: ["Input","Style"],
created: 'June 28, 2023',
modified: 'June 28, 2023',
path: '/mikeysAmazingTestPlayground/Input-Text-Color-Test',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundInputTextColorTest/>
},
{ id: '/mikeysAmazingTestPlayground/Local-Autocomplete',
name: 'Local Autocomplete implementation',
description: 'Autocomplete, implemented from MS Teams code snippet',
tags: ["Autocomplete"],
created: 'March 14, 2023',
modified: 'March 14, 2023',
path: '/mikeysAmazingTestPlayground/Local-Autocomplete',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundLocalAutocomplete/>
},
{ id: '/mikeysAmazingTestPlayground/MultiSelectChip-with-no-Clear-Button',
name: 'MultiSelectChip with No Clear Button and a Persistent Filter',
description: 'An altered version of MultiSelectChip that will allow you to do this',
tags: ["Multi Select Chip","Proof of Concept","Chips"],
created: 'September 1, 2023',
modified: 'September 1, 2023',
path: '/mikeysAmazingTestPlayground/MultiSelectChip-with-no-Clear-Button',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundMultiSelectChipwithnoClearButton/>
},
{ id: '/mikeysAmazingTestPlayground/Navigation-Menu-V2-with-long-names',
name: 'NavigationMenu with long Grandchildren names',
description: 'Testing a long indented grandchild name in the navigation menu',
tags: ["Navigation Menu V2"],
created: 'June 9, 2023',
modified: 'June 9, 2023',
path: '/mikeysAmazingTestPlayground/Navigation-Menu-V2-with-long-names',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundNavigationMenuV2withlongnames/>
},
{ id: '/mikeysAmazingTestPlayground/Pdf-Viewer',
name: 'PDF Viewer Proof of Concept',
description: 'A button that begins the workflow to upload and view a PDF file',
tags: ["PDF Viewer","Proof of Concept","PDF"],
created: 'May 3, 2023',
modified: 'May 3, 2023',
path: '/mikeysAmazingTestPlayground/Pdf-Viewer',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundPdfViewer/>
},
{ id: '/mikeysAmazingTestPlayground/Simple-Autocomplete-POC',
name: 'Simple Autocomplete',
description: 'A possible simple autocomplete component Proof of Concept',
tags: ["Autocomplete","Simple Autocomplete","Proof of Concept"],
created: 'March 6, 2024',
modified: 'March 6, 2024',
path: '/mikeysAmazingTestPlayground/Simple-Autocomplete-POC',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundSimpleAutocompletePOC/>
},
{ id: '/mikeysAmazingTestPlayground/Simple-Simple-Table-with-disabled-row',
name: 'A Simple Table with Disabled Rows',
description: 'Using the simple Simple Table pattern to show a disabled row',
tags: ["Simple Table","Disabled"],
created: 'May 20, 2024',
modified: 'May 20, 2024',
path: '/mikeysAmazingTestPlayground/Simple-Simple-Table-with-disabled-row',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundSimpleSimpleTablewithdisabledrow/>
},
{ id: '/mikeysAmazingTestPlayground/Single-Select-Dropdown',
name: 'Single Select Dropdown with Local Menu component',
description: 'The Single Select Dropdown [Storybook Code Snippet](https://svc-radial-storybook.ext.nebula.connectcdk.com/?path=/docs/components-menus-composed-examples-dropdown-menu--single-select-dropdown), implemented with a local menu from cdk-radial 6.4.0',
tags: ["Menu","Single Select Dropdown","Storybook Code Snippet"],
created: 'February 10, 2023',
modified: 'February 14, 2023',
path: '/mikeysAmazingTestPlayground/Single-Select-Dropdown',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundSingleSelectDropdown/>
},
{ id: '/mikeysAmazingTestPlayground/Table-Header-Title-With-Icon',
name: 'Table Header with Icon in Title',
description: 'A way to show a single icon to the right of a table header title',
tags: ["Table","Table Header"],
created: 'May 13, 2024',
modified: 'May 13, 2024',
path: '/mikeysAmazingTestPlayground/Table-Header-Title-With-Icon',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundTableHeaderTitleWithIcon/>
},
{ id: '/mikeysAmazingTestPlayground/Tooltip-issue',
name: 'Debugging a Tooltip Switch issue',
description: 'Just doing some testing',
tags: ["tooltip","switch"],
created: 'July 28, 2023',
modified: 'July 28, 2023',
path: '/mikeysAmazingTestPlayground/Tooltip-issue',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundTooltipissue/>
},
{ id: '/mikeysAmazingTestPlayground/pi1-Demo',
name: 'Mike Haines Demo Sprints 3-5 CY23 PI1',
description: 'PI1 Demo',
tags: ["Demo","Tabs"],
created: 'March 20, 2023',
modified: 'March 23, 2023',
path: '/mikeysAmazingTestPlayground/pi1-Demo',
route: '/mikeysAmazingTestPlayground',
component: <MikeysAmazingTestPlaygroundpi1Demo/>
},
{ id: '/peters-playground/Custom-Autocomplete-Checkboxes',
name: 'Custom Autocomplete Checkboxes',
description: 'This is a skeleton of a custom component to handle auto-complete style filtering of a checkbox list.',
tags: ["Autocomplete","Custom Component","Checkbox"],
created: 'March 6, 2024',
modified: 'March 6, 2024',
path: '/peters-playground/Custom-Autocomplete-Checkboxes',
route: '/peters-playground',
component: <PetersplaygroundCustomAutocompleteCheckboxes/>
},
{ id: '/peters-playground/Sidesheet-Example-Outside-Click',
name: 'SideSheet V2',
description: 'A simpler implementation of modal sidesheet',
tags: ["Sidesheet"],
created: 'March 15, 2024',
modified: 'March 15, 2024',
path: '/peters-playground/Sidesheet-Example-Outside-Click',
route: '/peters-playground',
component: <PetersplaygroundSidesheetExampleOutsideClick/>
},
{ id: '/poc-enter-as-tab/Enter-As-Tab',
name: 'Enter as Tab key experiments',
description: 'Testing to see how we can implement a key handler to make the Enter key act as the tab key',
tags: ["key events","tab","numpad enter"],
created: 'August 9, 2023',
modified: 'August 9, 2023',
path: '/poc-enter-as-tab/Enter-As-Tab',
route: '/poc-enter-as-tab',
component: <PocenterastabEnterAsTab/>
},
{ id: '/support-questions/DatePicker-Select-Typing',
name: 'DatePicker Missing Characters',
description: 'Report of DatePicker missing the first character when focused by tabbing in.',
tags: ["DatePicker"],
created: 'June 13, 2024',
modified: 'June 13, 2024',
path: '/support-questions/DatePicker-Select-Typing',
route: '/support-questions',
component: <SupportquestionsDatePickerSelectTyping/>
}, 
];

export default examples;